import { carbonTargetsStore } from "../stores";

export const useCarbonTargetsStore = () => carbonTargetsStore;
